<template>
  <b-dropdown
    v-if="items"
    id="dropdown-form"
    ref="downdownItem"
    class="filter-dropdown"
    size="sm"
    scrollParent="window"
    :text="filterText"
    :toggle-class="filterClass"
  >
    <b-dropdown-form>
      <div class="input-clear mb-1">
       <b-form-input trim 
          @keydown.enter.prevent="enterHandler"
          :placeholder="$t('SEARCH')"
          v-model="searchText"></b-form-input>
        <div
          class="input-clear-button"
          v-if="searchText != ''"
          @keydown.enter.prevent="enterHandler"
          @click="searchText = ''"
        >x</div>
      </div>
      <div class="dropdown-scroll px-2">
      <b-dropdown-form v-for="(item, index) in filterItems" :key="index">
          <b-form-checkbox
            size="sm"
            @change="updateInput"
            v-model="items"
            name="check-button"
            :value="item.id"
          >{{ item.text }}<span v-if="item.description"
              >&nbsp;<i
                class="fal fa-info-circle"
                v-b-tooltip.hover
                :title="item.description"
              ></i
            ></span></b-form-checkbox>
        </b-dropdown-form>
      </div>
    </b-dropdown-form>    
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-form>	
        <b-button class="no-border" size="sm"
        @click="closeFilter"
        >{{ $t("CLOSE") }}</b-button>
      <b-button class="no-border" size="sm"
      v-if="filterItems.length != 0"
      @click="clearFilter"
      >{{ $t("CLEAR") }}</b-button>
    </b-dropdown-form>
  </b-dropdown>
</template>
<script>
export default {
  props: {
    filterData: {
      default: () => [],
      type: Array,
    },
    value: {
      type: Array,
      Default: [],
    },
    title: {
      default: "",
      type: String,
    }
  },
  data() {
    return {
      items: this.value,
      selected: [],
      searchText: "",
    };
  },
  methods: {
    enterHandler(){
      return false;
    },
    closeFilter() {
      this.$refs.downdownItem.visible = false;
    },
    clearFilter() {
      this.items = [];
      this.updateInput();
    },
    updateInput() {
      this.$emit("input", this.items);
    },
    getName(id) {
      let name = this.filterData.filter((item) => {
        return item.id == id;
      });
      if(name.length != 0)
      {
        name = name[0].text;
        return this.Truncate(name,12);
      }else{
        return this.title;
      }
      
    },
  },
  computed: {
    filterItems() {
      if(this.searchText == "")
      {
        return this.filterData.filter((item) => {
            let check = this.items.filter((checkItem) => {
              return checkItem == item.id;
            });
            return check.length != 0;
        });
      }else{
        return this.filterData.filter((item) => {
          return (
            item.id.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1 ||
            item.text.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1
          );
        });
      }
    },
    filterClass() {
      if (this.items.length != 0) {
        return ["filter-selected", "no-border"];
      } else {
        return ["no-border"];
      }
    },
    filterText() {
      if (this.items.length != 0) {
        if (this.items.length > 1) {
          return (
            this.title +
            ": " +
            this.getName(this.items.slice().sort()[0]) +
            " +(" +
            (this.items.length - 1) +
            ")"
          );
        } else {
          return this.title + ": " + this.getName(this.items.slice().sort()[0]);
        }
      } else {
        return this.title;
      }
    },
  },
  mounted() {},
};
</script>
<style></style>
